import React, { useEffect, useState } from 'react'

// Абсолютный путь до скрипта tads
const tadsScriptUrl = 'https://w.tads.me/widget.js'

const getScript = (onLoad, onError) => {
  const addedScript = document.querySelector(`script[src="${tadsScriptUrl}"]`)

  if (addedScript) {
    return addedScript
  }

  const script = document.createElement('script')
  script.src = tadsScriptUrl
  script.async = true
  script.addEventListener('load', onLoad)
  script.addEventListener('error', onError)
  document.body.appendChild(script)

  return script
}

/**
 * Preconnect to our api
 */
const addPreconnect = () => {
  const linkElement = document.createElement('link');

  linkElement.rel = 'preconnect'
  linkElement.href = 'https://api.tads.me'

  document.head.appendChild(linkElement)
}

export const renderTadsWidget = ({ id, type = 'fullscreen' }) => {
  if (!window.tads || !window.tads.controllers) {
    console.warn('Tads not initialized')
    return
  }

  const adController = window.tads.controllers[id]

  if (!adController) {
    console.warn(`No ad controller found for widget ID: ${id}`)
    return
  }

  if (typeof adController.showAd !== 'function') {
    console.warn(`showAd is not available for widget ID: ${id}`)
    return
  }

  adController
    .showAd()
    .catch(err => {
      console.error(`Error while showing ${type} ad for widget ${id}:`, err)
    })
}

export const TadsWidget = ({ id, debug, type = 'STATIC', onShowReward, onClickReward, onAdsNotFound }) => {
  const [scriptState, setScriptState] = useState({
    isLoaded: false,
    isError: false,
    isShown: false
  })

  useEffect(() => {
    if (scriptState.isShown) return
    setScriptState(s => ({ ...s, isShown: true }))

    let widgetScript

    const insertScript = (onLoad, onError) => {
      if (window.tads) {
        onLoad()
      } else {
        widgetScript = getScript(
          () => setScriptState(x => ({ ...x, isLoaded: true, isError: false })),
          () => setScriptState(x => ({ ...x, isLoaded: false, isError: true }))
        )

        if (scriptState.isLoaded) onLoad()
        if (scriptState.isError) onError()

        widgetScript.addEventListener('load', onLoad)
        widgetScript.addEventListener('error', onError)
      }
    }

    const handleScriptError = () => {
      console.error('Failed to load Tads script.')
    }

    insertScript(() => {
      if (!window.tads.controllers) window.tads.controllers = {}

      const adController = window.tads.init({
        widgetId: id,
        type: type.toUpperCase(),
        debug,
        onShowReward,
        onClickReward,
        onAdsNotFound
      })

      window.tads.controllers[id] = adController

      // Только для STATIC вызываем loadAd заранее
      if (type.toUpperCase() === 'STATIC') {
        adController
          .loadAd()
          .then(data => data.type === 'STATIC' && adController.showAd())
          .catch(console.log)
      }
    }, handleScriptError)

    return () => {
      if (widgetScript) {
        widgetScript.removeEventListener('load', () => {})
        widgetScript.removeEventListener('error', () => {})
        widgetScript.remove()
        setScriptState({ isLoaded: false, isError: false, isShown: false })
      }
    }
  }, [id, debug, type, onShowReward, onClickReward, onAdsNotFound])

  return <div id={`tads-container-${id}`}></div>
}

export const TadsWidgetProvider = (props) => {
  useEffect(() => {
    addPreconnect()

    getScript(
      () => {
        console.log('script load')
      },
      () => {
        console.error('script error')
      }
    )
  }, [])

  return <>{props.children}</>
}

export default TadsWidget
